// Scrolling to hash when page loads turned out to be a huge pain.
// Therefore -> do it ugly and the JS way.
// {@link https://github.com/ReactTraining/react-router/issues/394#issuecomment-220221604}
export const scrollToHash = () => {
  const { hash } = window.location;
  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
};



// WEBPACK FOOTER //
// ./src/utils/scrollToHash.js